import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { FilterSelect, SpinnerLoader } from '@warrenbrasil/nebraska-web';

import { PortfolioChartFilter } from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  isLoading: boolean;
  hasError: boolean;
  periodFilters: PortfolioChartFilter[];
  benchmarkFilters: PortfolioChartFilter[];
}
interface Emits {
  (e: 'on-period-filter-change', value: string): void;
  (e: 'on-benchmark-filter-change', value: string): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceHeader',
  props: {
    isLoading: { type: Boolean },
    hasError: { type: Boolean },
    periodFilters: null,
    benchmarkFilters: null
  },
  emits: ["on-period-filter-change", "on-benchmark-filter-change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-period-filter-change', value: string): void;
  (e: 'on-benchmark-filter-change', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isLoading: boolean;
  hasError: boolean;
  periodFilters: PortfolioChartFilter[];
  benchmarkFilters: PortfolioChartFilter[];
}





const activePeriodFilter = computed(() => {
  const filter = props.periodFilters?.find(filter => filter.active);
  return {
    value: filter?.key || '',
    label: filter?.label || '-'
  };
});

const activeBenchmarkFilter = computed(() => {
  const filter = props.benchmarkFilters?.find(filter => filter.active);
  return {
    value: filter?.key || '',
    label: filter?.label || '-'
  };
});

const hasFilter = computed(() => {
  return props.benchmarkFilters?.length > 0 || props.periodFilters?.length > 0;
});

const emitPeriodFilterChange = (value: string) => {
  emit('on-period-filter-change', value);
};

const emitBenchmarkFilterChange = (value: string) => {
  emit('on-benchmark-filter-change', value);
};

return { __sfc: true,props, emit, activePeriodFilter, activeBenchmarkFilter, hasFilter, emitPeriodFilterChange, emitBenchmarkFilterChange, FilterSelect, SpinnerLoader, NebraskaColors }
}

})